import React from 'react';
import Skeleton from "../../../../shared/molecules/Skeleton/Skeleton";
import "./StrategyMapActionHeader.css";

export function StrategyMapActionSkeleton() {
    return (
        <div className="sma-header">
            {/* Left side - View switcher skeleton */}
            <div className="flex items-center">
                <div className="sma-switcher-container">
                    <div className="px-3.5 py-1.5">
                        <Skeleton width={80} height={20} className="rounded-lg" />
                    </div>
                    <div className="px-3.5 py-1.5 border-l border-light-border-default dark:border-gray-600">
                        <Skeleton width={80} height={20} className="rounded-lg" />
                    </div>
                </div>

                {/* Dropdown skeleton */}
                <div className="ml-4">
                    <Skeleton width={150} height={32} className="rounded-lg" />
                </div>
            </div>

            {/* Right side - Statistics and Date Range skeleton */}
            <div className="sma-stats-wrapper">
                <div className="sma-stats-group">
                    {/* At Risk Stat Skeleton */}
                    <div className="sma-stat-item">
                        <Skeleton width={60} height={14} className="mb-1" />
                        <div className="flex items-center">
                            <Skeleton variant="circular" width={12} height={12} />
                            <Skeleton width={30} height={16} className="ml-2" />
                        </div>
                    </div>

                    {/* On Track Stat Skeleton */}
                    <div className="sma-stat-item">
                        <Skeleton width={60} height={14} className="mb-1" />
                        <div className="flex items-center">
                            <Skeleton variant="circular" width={12} height={12} />
                            <Skeleton width={30} height={16} className="ml-2" />
                        </div>
                    </div>

                    {/* Completed Stat Skeleton */}
                    <div className="sma-stat-item">
                        <Skeleton width={60} height={14} className="mb-1" />
                        <div className="flex items-center">
                            <Skeleton variant="circular" width={12} height={12} />
                            <Skeleton width={30} height={16} className="ml-2" />
                        </div>
                    </div>
                </div>

                {/* Others Section Skeleton */}
                <div className="flex flex-col items-start gap-1">
                    <Skeleton width={50} height={14} />
                    <div className="flex items-center">
                        <Skeleton variant="circular" width={12} height={12} />
                        <Skeleton width={20} height={16} className="ml-2" />
                    </div>
                </div>

                {/* Date Section Skeleton */}
                <div className="sma-date-section">
                    <Skeleton width={100} height={12} className="mb-1" />
                    <Skeleton width={150} height={16} />
                </div>
            </div>
        </div>
    );
}

export default StrategyMapActionSkeleton;